import ApiUrl from "@/config/api_url";
import WebApiUrl from "@/config/WebApiUrl";
import { dataCeneter } from "@/data/DataCenter";

import Vue from "vue";

var url = ApiUrl;
var url2 = WebApiUrl;

for (var key in url2) {
  url[key] = url2[key];
}

export const httpService = {
  api: ApiUrl,
  ajax: function (ajaxData, postData) {
    var promiseData = {};

    if (typeof ajaxData == "string") {
      // 處理post 只帶2個參數的例外狀況
      promiseData.url = ajaxData;
      promiseData.data = postData;
      promiseData.method = "post";
    } else {
      promiseData = ajaxData;
    }
    if (promiseData.timeout == undefined) {
      promiseData.timeout = 3600000;
    }
    var headers = {};
    if (dataCeneter != null) {
      var user = dataCeneter.getData();
      if (user.loginToken != null) {
        headers["Token"] = user.loginToken;
      }
    }
    /*
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({
           Account:$("#txtAccount").val(),
           Password:$("#txtPassword").val()
       }),
*/

    // 過濾掉第一層的空字串 轉為null
    if (ajaxData.disableStringVerfiy != true) {
      Object.keys(promiseData.data).forEach(function (key) {
        if (
          typeof promiseData.data[key] == "string" &&
          promiseData.data[key] == ""
        ) {
          promiseData.data[key] = null;
        }
      });
    }

    var isDone = false;
    var isAlertShow = false;
    setTimeout(() => {
      // 如果超過0.7秒 API 還沒回應，跳出Loading 視窗
      if (
        isDone == false &&
        promiseData?.method == null &&
        promiseData.disableLoading != true &&
        promiseData?.nonehideLoading !== true
      ) {
        window.$alert.showLoading();
        isAlertShow = true;
      }
    }, 700);
    // 暫存API 發送時間
    let temp_sendDate = new Date().toLocaleString('zh-TW', {timeZone: 'Asia/Taipei'});

    var promise = $.ajax({
      type: promiseData?.method ?? "POST",
      contentType: promiseData.contentType ?? "application/json",
      // dataType: promiseData.dataType ?? "json",
      headers: headers,
      data:
        promiseData.contentType != null
          ? promiseData.data
          : JSON.stringify(promiseData.data),
      async: promiseData?.async ?? true,
      url: promiseData.url,
      processData: promiseData?.processData,
      timeout: promiseData.timeout,
    })
      .done(function (responseData, status, xhr) {
        isDone = true;

        // 把發送的資料記錄下來
        if (promiseData.contentType == null && headers.Token != null) {
          promiseData.data.LOG_temp_sendDate = temp_sendDate;
          // jsonAPI 才紀錄
          vm.$logCenter.addOperationToLog({
            ApiName: promiseData.url,
            InputValue: promiseData.data,
            Status: responseData.success ? 1 : 0,
            content: responseData,
            Msg: responseData.errDesc,
          });
        }

        if (isAlertShow) {
          window.$alert.hideLoading();
        }

        // preconfigured logic for success
        if (responseData.status == 901) {
          Vue.$alert.show("登入失效", responseData.ErrDesc);
        } else if (responseData.status == 407) {
          var errDesc = responseData.errDesc;

          // 使用者登入到期
          Vue.prototype.$alert.showWarning(
            "登入失效",
            errDesc?.indexOf("停用") != -1 ? errDesc : "登入已失效，請重新登入",
            function () {
              // Remove userData from localStorage
              // 清除登入資料
              localStorage.removeItem("userData");
              localStorage.removeItem("dataCenter");

              let checksystem = dataCeneter.user.clientsystem;
              console.log("checksystemchecksystem", checksystem);

              if (window.location?.pathname?.includes("/Ant/") == true) {
                if (checksystem == "buyer_seller") {
                  window.location = "/Ant/login/buyer_seller";
                } else if (checksystem == "real_estate") {
                  window.location = "/Ant/login/real_estate";
                } else if (checksystem == "scrivener") {
                  window.location = "/Ant/login/scrivener";
                } else {
                  window.location = "/Ant/login/class";
                }
              } else {
                if (checksystem == "buyer_seller") {
                  window.location = "/login/buyer_seller";
                } else if (checksystem == "real_estate") {
                  window.location = "/login/real_estate";
                } else if (checksystem == "scrivener") {
                  window.location = "/login/scrivener";
                } else {
                  window.location = "/login/class";
                }
              }
            }
          );
          return;
        }

        if (responseData?.ErrDesc == null && responseData?.message != null) {
          responseData.ErrDesc = responseData?.message;
          responseData.errDesc = responseData.ErrDesc;
        }
        promiseData.done(responseData, status, xhr);
        dataCeneter.user.reciprocal = dataCeneter.user.reciprocal + 1;
        dataCeneter.saveData();
      })
      .fail(function (xhr, status, err) {
        isDone = true;

        if (isAlertShow) {
          window.$alert.hideLoading();
        }

        //predetermined logic for unsuccessful request
        promiseData.fail(xhr, status, err);
      });
  },
  // 取得 User承辦區域代書清單 (業務系統用)

  getUserAreaList: function (callback) {
    var dataToPost = {};
    this.ajax({
      url: this.api.GetUserAreaList,
      data: dataToPost,
      done: function (response, _status, _jqxhr) {
        // this is the "success" callback

        if (response.success == true) {
          if (callback != null) {
            var data = {
              UserAreaList: [
                {
                  value: null,
                  text: "全選",
                },
              ],
              UserWriteLegalList: [
                {
                  value: null,
                  text: "全選",
                },
              ],
            };

            for (var index in response.viewModel?.areaList) {
              var item = response.viewModel?.areaList[index];
              data.UserAreaList.push({
                value: item.areaID,
                text: item.areaName,
              });
            }

            for (var index in response.viewModel?.writeLegalList) {
              var item = response.viewModel?.writeLegalList[index];
              data.UserWriteLegalList.push({
                value: item.writeLegalID,
                text: item.writeLegalName,
              });
            }

            callback(data);
          }
          // vm.$dataCenter.userAreaList = response.viewModel?.areaList;
          // vm.$dataCenter.userWriteLegalListt =
          //   response.viewModel?.writeLegalList;
        } else {
          vm.$alert.showError("Error", response.errDesc);
        }
      }.bind(this),
      fail: function (_jqxhr, _status, error) {
        this.table.isLoading = false;
        this.$alert.showError("Error", "無法連線伺服器，請稍後再試");

        console.log(error);
      }.bind(this),
    });
  },
};
